<div class="teaser-bet-linear-summary_points">{{ teaserText }}</div>
<bs-linear-container-summary [showOdds]="true" [oddsDisplayFormat]="oddsDisplayFormat" [indicateOddsChange]="false" />
